import React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import DashboardTabs from './DashboardTabs';
import { useDashboardProps } from '../../App';

function DashboardContent() {
    const { activeTab, collapseHeader, onTabChange } = useDashboardProps();
    const navigate = useNavigate();
    const location = useLocation();

    // Track the previous active tab to detect tab changes
    const prevActiveTabRef = React.useRef(null);
    const isInitialMount = React.useRef(true);

    // Update navigation when tab changes or on initial load
    React.useEffect(() => {
        const tabPaths = {
            'projects': '/projects',
            'weekly-planner': '/weekly-planner',
            'recurring-tasks': '/recurring-tasks',
            'timeblock': '/timeblock'
        };

        const targetPath = tabPaths[activeTab];
        
        // Navigate if:
        // 1. On initial mount (force default startup screen)
        // 2. The tab changed (user clicked a tab)
        if (targetPath) {
            const shouldNavigate = 
                isInitialMount.current ||
                (prevActiveTabRef.current !== null && prevActiveTabRef.current !== activeTab);
            
            if (shouldNavigate) {
                if (isInitialMount.current) {
                    navigate(targetPath, { replace: true });
                } else {
                    // For manual tab changes, navigate to the tab overview
                    if (activeTab === 'projects') {
                        navigate(targetPath, { replace: true });
                    } else if (!location.pathname.includes(targetPath)) {
                        navigate(targetPath, { replace: true });
                    }
                }
            }
            
            // Update the refs after handling
            prevActiveTabRef.current = activeTab;
            isInitialMount.current = false;
        }
    }, [activeTab, navigate, location.pathname]);

    return (
        <main className={`
            bg-[var(--app-bg)]
            text-[var(--text-primary)]
            font-sans 
            flex-1 
            overflow-auto 
            ${collapseHeader ? 'pt-14' : 'pt-24'}
            pb-8
            min-w-[300px]
            ml-[60px]
        `}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <DashboardTabs 
                    activeTab={activeTab} 
                    onTabChange={onTabChange} 
                />
                <div className="bg-[var(--surface-bg)] shadow-lg rounded-lg border border-[var(--surface-border)] overflow-hidden">
                    <div className="p-4 sm:p-6 overflow-x-hidden">
                        <Outlet />
                    </div>
                </div>
            </div>
        </main>
    );
}

export default DashboardContent; 